<!-- Header -->
<lib-app-header
  [actions]="headerMenuItems"
  [actionsMobile]="headerMenuMobileItems"
  [aisUrl]="aisUrl"
  [appTitleShort]="appName"
  [appTitle]="appName"
  [languageLinks]="languageLinks"
  [red]="red"
  [userName]="username"
  [translate]="translate"
></lib-app-header>

<div class="container-fluid app-container" [ngClass]="{'ais-red': red}" *ngIf="userLogged; else notLogged">

  <div class="row">

    <div class="col-md-2"></div>

    <div id="col2" class="col-md-2">

      <app-info></app-info>
      <div class="d-none d-md-block">
        <app-aplikacie></app-aplikacie>
      </div>
      <div class="d-none d-md-block mt-3">
        <app-diskusia></app-diskusia>
      </div>

    </div>

    <div id="col3" class="col-md-8">

      <app-banner *ngIf="showBanner"></app-banner>

      <app-flash-message-list></app-flash-message-list>

      <router-outlet (activate)="onActivate()"></router-outlet>

      <app-reklama></app-reklama>

    </div>

  </div>

  <div class="row d-block d-md-none mb-4"></div>

</div>

<ng-template #notLogged>
  <div class="container app-container">
    <lib-auth-error></lib-auth-error>
  </div>
</ng-template>

<!-- Footer -->
<lib-app-footer [red]="red"></lib-app-footer>


